import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import { Box, Typography, useTheme } from '@mui/material';

interface RichTextFieldProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    height?: number;
    fullWidth?: boolean;
    onBlur?: () => void;
    onFocus?: () => void;
    style?: React.CSSProperties;
}

export const RichTextField: React.FC<RichTextFieldProps> = ({
    value,
    onChange,
    placeholder = '',
    height = 120,
    fullWidth = true,
    onBlur,
    onFocus,
    style,
}) => {

    const theme = useTheme();

    const [focused, setFocused] = useState(false);

    const handleFocus = () => {
        setFocused(true);
        onFocus?.();
    };

    const handleBlur = () => {
        setFocused(false);
        onBlur?.();
    };

    return (
        <>
            <style>
                {`
                    .custom-quill-editor .ql-container {
                        border-radius: 4px;
                        border: none;
                        overflow: hidden;
                    }

                    .custom-quill-editor .ql-toolbar {
                        border-radius: 4px;
                        border: none;
                        margin-bottom: 8px;
                    }

                    .custom-quill-editor .ql-editor {
                        min-height: 80px;
                        border: none;
                        border: none;
                    }

                    .custom-quill-editor {
                        border: 1px solid ${theme.palette.divider};
                        border-radius: 4px;
                    }
                `}
            </style>

            <Typography variant="body2" color="text.primary">
                <ReactQuill
                    className="custom-quill-editor"
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    theme="snow"
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                />
            </Typography>
        </>
    );
};
